module.exports = __webpack_public_path__ + "static/optometrist-advising-woman-choosing-glasses-dd0458fffa0d08c620d0065407438d7e.png";